import React, { useState, useEffect } from 'react';

// Define enum for form states
const FormStates = {
  IDLE: 'idle',
  SUBMITTING: 'submitting',
  SUBMITTED: 'submitted',
  FAILED: 'failed',
  TIMEOUT: 'timeout',
};

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [formState, setFormState] = useState(FormStates.IDLE);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormState(FormStates.SUBMITTING);

    try {
      const response = await fetch('http://127.0.0.1:8000/api/contact-us/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormState(FormStates.SUBMITTED);
      } else {
        setFormState(FormStates.FAILED);
      }
    } catch (error) {
      setFormState(FormStates.TIMEOUT);
      console.error('Error submitting form:', error);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setFormState(FormStates.IDLE);
    }, 5000);

    return () => clearTimeout(timer);
  }, [formState]);

  return (
    <div className='w-full min-h-80 bg-white mb-0'>
    <div className=" rounded-md border border-blue-200 max-w-md mx-auto bg-slate-100 ">
      <form onSubmit={handleSubmit}>
        <label className="block mt-4 p-4 ">
          Name:
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="form-input mt-1 block w-full rounded-md border-gray-300 focus:border-blue-400 focus:ring focus:ring-blue-400"
            required
          />
        </label>
        <label className="block mt-2 p-4">
          Email:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="form-input mt-1 block w-full rounded-md border-gray-300 focus:border-blue-400 focus:ring focus:ring-blue-400"
            required
          />
        </label>
        <label className="block mt-2 p-4">
          Subject:
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            className="form-input mt-1 block w-full rounded-md border-gray-300 focus:border-blue-400 focus:ring focus:ring-blue-400"
            required
          />
        </label>
        <label className="block mt-1 p-4">
          Message:
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="form-textarea mt-1 block w-full rounded-md border-gray-300 focus:border-blue-400 focus:ring focus:ring-blue-400"
            required
          />
        </label>
        <button
          type="submit"
          className={`mt-4 w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-md transition duration-300 ${
            formState === FormStates.SUBMITTING && 'opacity-50 cursor-not-allowed'
          }`}
          disabled={formState === FormStates.SUBMITTING}
        >
          {formState === FormStates.SUBMITTING ? 'Submitting...' : 'Submit'}
        </button>
        {formState === FormStates.SUBMITTED && (
          <p className="mt-2 text-green-600">Form submitted successfully!</p>
        )}
        {formState === FormStates.FAILED && (
          <p className="mt-2 text-red-600">Failed to submit form. Please try again later.</p>
        )}
        {formState === FormStates.TIMEOUT && (
          <p className="mt-2 text-red-600">Error: Could not reach API. Please try again later.</p>
        )}
      </form>
    </div>
    </div>
  );
};

export default ContactForm;
